module.exports = __webpack_public_path__ + "img/small-ship-wreck-a.47e930fe.png";